import React from "react";
import TweetList from "../TweetList/TweetList";

const HomeComponent = () => {
    return(
      <>
       <TweetList/>
      </>
  );
}
export default HomeComponent;
